module.exports = __webpack_public_path__ + "static/img/share-logo.bd64f03c.png";